import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { AppContext } from '../store';
import { UITypes } from '../store/actions';


const MobileResourceToggle = () => {
    const { state, dispatch } = useContext(AppContext);
    const handleChange = () => {
        dispatch({
            type: UITypes.setUI,
            payload: {
                ...state.uiInfo,
                drawer_expanded: !state.uiInfo.drawer_expanded,
                is_mobile: true,
            },
        });
    }
    return <div className="w-100 d-block d-lg-none fixed-bottom p-3 d-print-none" style={{ backgroundColor: 'rgb(189 198 204)' }}>
        <div className="mx-auto" style={{ width: '100px' }}>Menu &nbsp;
            <Button size="sm" variant="outline-secondary" className="mx-auto" onClick={handleChange} data-testid="mobile-resource-toggler">
                {state.uiInfo.drawer_expanded ? <FontAwesomeIcon icon="times" /> : <FontAwesomeIcon icon="bars" />}
            </Button>
        </div>
    </div>;
};

export default MobileResourceToggle;
